import OnboardingLayoutContentNarrow from './OnboardingLayoutContentNarrow';

export default OnboardingLayoutContentNarrow;
